import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { VegaSong } from 'services/store/ai/types';
import { DownloadInfo } from 'types';
import useAnalytics from '../useAnalytics';

const useTrackAISongDownload = (
  genre: VegaSong['genre'],
  title: VegaSong['title'],
  songType: VegaSong['songType'],
  location: AnalyticsEventLocation
) => {
  const { track } = useAnalytics();

  const trackDownload = (downloadInfo: DownloadInfo) => {
    track(
      events.downloadEvent(
        title,
        genre ?? '',
        downloadInfo,
        true,
        songType,
        location
      )
    );
  };

  return { trackDownload };
};

export default useTrackAISongDownload;
